// Constants
// -----------------------------------------------------------------------------
export const BASE_TABLE_TD_ALIGN = 'left';
//# sourceMappingURL=BaseTableTD.constants.js.map